define('AwaLabs.SuggestedFoodPairing', [
    'SuggestedFoodPairing.View'
], function AwaLabsSuggestedFoodPairing(
    SuggestedFoodPairingView
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var pdp = container.getComponent('PDP');
            var environment = container.getComponent('Environment');
            var config = environment.getConfig('SuggestedFoodPairing');

            if (pdp) {
                pdp.addChildViews(
                    pdp.PDP_FULL_VIEW, {
                        'SuggestedFoodPairing': function SuggestedFoodPairing() {
                            return new SuggestedFoodPairingView({
                                pdp: pdp,
                                application: container,
                                config: config
                            });
                        }
                    }
                );
            }
        }
    };
});
